module.exports = __webpack_public_path__ + "static/media/11C.44e28002.jpg";